import React, { useEffect, useState } from "react";
import Loader from "../../../components/Loader";

import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import { extractDateFromStr } from "../../../Utils/utils";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import BondsTabs from "./BondsTabs";
import useSeo from "../../../hooks/useSeo";
import { useLocation } from "react-router-dom";

const BondsPage = () => {
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);
  const [activeTab, setActiveTab] = useState("");
  const [lastUpdated, setLastUpdated] = useState("");
  const { data: bondsData = [], isLoading: bondsIsLoading } =
    useGetProtectedApiDataQuery({
      url: "bonds",
      lang: languageType,
    });

  useEffect(() => {
    if (bondsData.length > 0) {
      const lastElement = bondsData[bondsData.length - 1];
      setActiveTab(lastElement.title);
      setLastUpdated(extractDateFromStr(lastElement.changed));
    }
  }, [bondsData, languageType]);

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });

  if (bondsIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        title={getText("Investors", "निवेशक")}
        titleLink="/investors/bonds"
        levelTwo={true}
        levelThree={false}
        bannerImage={innerBannerImage}
        titleTwo={innerBannerTitle}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            <PageLastUpdated lastUpdatedOn={lastUpdated} />
            <div className="row mt-2">
              <div className="col-12 col-sm-12 col-md-3 col-lg-3 print-left">
                <div className="innleft_section">
                  <ul className="menu nav nav-pills flex-column">
                    {bondsData
                      .slice()
                      .reverse()
                      .map((item, index) => (
                        <li key={index} className="nav-item">
                          <a
                            href="#"
                            className={`nav-link ${
                              activeTab === item.title ? "active" : ""
                            }`}
                            onClick={(e) => {
                              e.preventDefault();
                              setActiveTab(item.title);
                              setLastUpdated(extractDateFromStr(item.changed));
                            }}
                          >
                            <div
                              dangerouslySetInnerHTML={{ __html: item.title }}
                            ></div>
                          </a>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>

              <div className="col-12 col-sm-12 col-md-9 col-lg-9 print-right">
                {bondsData.map(
                  (item, index) =>
                    activeTab === item.title && (
                      <BondsTabs key={index} data={item} />
                    )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BondsPage;
